var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time',{key:_vm.dateKey,attrs:{"datetime":_vm.formattedDate,"title":_vm.$utils.formatDatetime(_vm.value)}},[_vm._v(" "+_vm._s(_vm.formattedDate))])
}
var staticRenderFns = []

export { render, staticRenderFns }